<template>
  <div class="wrap">
    <div class="about">
      <div class="aboutTitle">大会介绍</div>
      <div class="aboutEn">CONFERENCE INTRODUCTION</div>
      <div class="aboutInfo">
        <img src="https://p5.ssl.qhimg.com/t110b9a93016ebdde941290a4e3.png" alt="" class="aboutBg" />
        <div class="aboutText">
          <div class="aboutInfoTitle">{{ obj?.title }}</div>
        <div class="aboutInfoItem">{{ obj?.paraA }}</div>
        </div>
      </div>
    </div>
    <img src="https://p3.ssl.qhimg.com/t11b673bcd60311cb928564ae53.png" alt="" class="aboutImg" />
  </div>
</template>

<script setup>
const props = defineProps(['obj'])
const obj = props.obj || {}

</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background: #f3f3f3;
  padding-bottom: 73px;
  // background-color: pink;
}
.about {
  // width: 1600px;
  width: 90%;
  min-width: 1230px;
  margin: 0 auto;
  position: relative;
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    margin-top: 16px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
  }
  &Bg {
    width: 50%;
    // height: 450px;
    position: absolute;
    z-index: 99;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  &Text {
    margin-left: 15%;
    border-radius: 32px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    width: 85%;
    height: 560px;
    // padding-top: 79px;
    padding: 10% 0 0 37%;
  }
  &Info {
    z-index: 99;
    height: 560px;
    margin-top: 110px;
    &Title {
      font-family: Source Han Sans;
      font-size: 32px;
      font-weight: 500;
      line-height: 40px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
      // margin-left: 604px;
      margin-bottom: 40px;
    }
    &Item {
      width: 95%;
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: normal;
      line-height: 36px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-8 */
      color: #525966;
      margin-bottom: 32px;
      text-align: justify;
    }
  }
  &Img {
    position: absolute;
    width: 390px;
    height: 386px;
    top: 34px;
    right: -102px;
    z-index: 50;
    display: block;
  }
}
</style>
